import { Checkbox, PreloaderCircular } from '@shared/ui/kit';
import * as stylex from '@stylexjs/stylex';
import { styles } from '../../styles.ts';
import { InvitedParticipants } from '@widgets/segments-tab';
import { DepartmentNode } from '../../model/useFetchEmployeesTree.ts';
import { EmployeeTree } from '../employee-tree/index..tsx';

interface ParticipantsDepartmentsTabProps {
  departmentTree: DepartmentNode[];
  isFetching: boolean;
  searchString: string;
  selectedParticipants: number[];
  invitedParticipants: InvitedParticipants[];
  participantsDelete?: InvitedParticipants[];
  statusAllChecked: boolean;
  onAllCheck: () => void;
  setSelectedParticipants: (users: number[]) => void;
  setParticipantsDelete?: React.Dispatch<React.SetStateAction<InvitedParticipants[]>>;
}

export const ParticipantsDepartmentsTab: React.FC<ParticipantsDepartmentsTabProps> = ({
  departmentTree,
  isFetching,
  searchString,
  selectedParticipants,
  invitedParticipants,
  participantsDelete,
  statusAllChecked,
  onAllCheck,
  setSelectedParticipants,
  setParticipantsDelete,
}) => {
  if (isFetching) {
    return (
      <div {...stylex.props(styles.treeContainer)}>
        <div {...stylex.props(styles.loader)}>
          <PreloaderCircular />
        </div>
      </div>
    );
  }

  if (searchString && !departmentTree.length) {
    return (
      <div {...stylex.props(styles.participants)}>
        <div {...stylex.props(styles.emptyState)}>Поиск не дал результатов</div>
      </div>
    );
  }

  return (
    <div {...stylex.props(styles.participants)}>
      <div {...stylex.props(styles.departmentHeader)}>
        <div {...stylex.props(styles.departmentHeaderContent)}>
          <span {...stylex.props(styles.chevronSpacer)} />
          <Checkbox onChange={onAllCheck} isChecked={statusAllChecked} />
          <span {...stylex.props(styles.participant)}>Выбрать всех сотрудников</span>
        </div>
      </div>

      <div {...stylex.props(styles.treeContainer)}>
        <div {...stylex.props(styles.main)}>
          {departmentTree?.map((dept) => (
            <EmployeeTree
              key={dept.id}
              department={dept}
              searchString={searchString}
              selectedParticipants={selectedParticipants}
              setSelectedParticipants={setSelectedParticipants}
              invitedParticipants={invitedParticipants}
              setParticipantsDelete={setParticipantsDelete}
              participantsDelete={participantsDelete}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
